import { useEffect } from 'react';

export function IntroScreen() {
  // Lock body scroll when visible
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <div className="fixed inset-0 z-[100] bg-background flex flex-col items-center justify-center animate-fade-in">
      {/* Pre-headline */}
      <p className="text-muted-foreground text-sm mb-2">💯 in 365</p>
      
      {/* Main headline */}
      <h1 className="text-3xl font-serif font-bold text-foreground text-center mb-8">
        💯 Drinks
      </h1>

      {/* Loading indicator */}
      <div className="flex items-center gap-2">
        <span className="w-2 h-2 bg-primary rounded-full animate-pulse" style={{ animationDelay: '0ms' }} />
        <span className="w-2 h-2 bg-primary rounded-full animate-pulse" style={{ animationDelay: '150ms' }} />
        <span className="w-2 h-2 bg-primary rounded-full animate-pulse" style={{ animationDelay: '300ms' }} />
      </div>
    </div>
  );
}
